export default __webpack_public_path__ + "static/media/climaSLang.a096e4f8.jpg";